import { useEffect, useRef, useState } from 'react';
import { mountTurnstile } from './turnstile.mjs';

export default function ContactForm() {
  const container = useRef(null);
  const widget = useRef(null);
  const pending = useRef(false);
  const submission = useRef(null);
  const [token, setToken] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [verificationError, setVerificationError] = useState('');
  const [retry, setRetry] = useState(0);
  const es = location.pathname.startsWith('/es');
  useEffect(() => {
    let disposed = false;
    mountTurnstile(container.current, {
      siteKey: '0x4AAAAAAEz8rUALLZjR4j-c',
      onToken: value => { if (!disposed) setToken(value); },
      onError: value => { if (!disposed) setVerificationError(value ? (es ? 'No se pudo completar la verificación. Inténtalo de nuevo.' : value) : ''); },
    }).then(value => { if (disposed) value.destroy(); else widget.current = value; }).catch(() => {});
    return () => { disposed = true; widget.current?.destroy(); widget.current = null; };
  }, [retry, es]);
  async function submit(event) {
    event.preventDefault();
    if (pending.current) return;
    if (!token) { setMessage(es ? 'Espera a que termine la verificación.' : 'Please wait for verification to finish.'); return; }
    const form = event.currentTarget;
    submission.current ??= crypto.randomUUID();
    const data = new FormData(form);
    data.set('submission_id', submission.current);
    data.set('cf-turnstile-response', token);
    data.set('language', es ? 'es' : 'en');
    pending.current = true; setBusy(true); setMessage('');
    try {
      const response = await fetch('/api/contact.php', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('submit');
      form.reset(); submission.current = null;
      setMessage(es ? 'Gracias. Recibimos tu mensaje y nos pondremos en contacto contigo.' : 'Thank you. We received your message and will get back to you.');
    } catch {
      setMessage(es ? 'No pudimos enviar tu mensaje. Inténtalo de nuevo o llama al (956) 312-6097.' : 'We could not send your message. Please retry or call (956) 312-6097.');
    } finally { pending.current = false; setBusy(false); widget.current?.reset(); }
  }
  return <form className="contact-form" onSubmit={submit}>
    <h2>{es ? 'Envíanos un mensaje' : 'Send Us A Message'}</h2>
    <label>{es ? 'Nombre' : 'Name'}<input name="name" required maxLength={255} autoComplete="name" /></label>
    <label>{es ? 'Correo electrónico' : 'Email'}<input type="email" name="email" required maxLength={255} autoComplete="email" /></label>
    <label>{es ? 'Teléfono' : 'Phone'}<input type="tel" name="phone" maxLength={40} autoComplete="tel" /></label>
    <label>{es ? 'Mensaje' : 'Message'}<textarea name="message" rows="6" required maxLength={5000} /></label>
    <div hidden aria-hidden="true"><label>Website<input name="website" tabIndex={-1} autoComplete="off" /></label></div>
    <div ref={container} />
    {verificationError && <div role="alert"><p>{verificationError}</p><button type="button" onClick={() => setRetry(value => value + 1)}>{es ? 'Reintentar verificación' : 'Retry verification'}</button></div>}
    <p role="status" aria-live="polite">{message}</p>
    <button className="button" type="submit" disabled={busy || !token}>{busy ? (es ? 'Enviando…' : 'Sending…') : (es ? 'Enviar mensaje' : 'Send message')}</button>
  </form>;
}
